module.exports = __webpack_public_path__ + "static/media/male-back-hamstrings-hamstrings-a.01ee4c74.png";